























import { Component, Prop, Vue } from 'vue-property-decorator';
import Plant from '@/models/plant';
import {
  create as createPlant,
  update as updatePlant,
  remove as removePlant
} from '@/api/plants';

@Component
export default class PlantDetails extends Vue {
  @Prop(Object) value!: Plant;
  plant: Plant;

  constructor() {
    super();
    this.plant = this.value;
  }

  async save() {
    try {
      this.plant = await (this.plant.id
        ? updatePlant(this.plant.id, this.plant)
        : createPlant(this.plant));
      this.$router.replace({
        name: 'PlantView',
        params: { id: String(this.plant.id) }
      });
      this.$emit('input', this.plant);
    } catch (e) {
      this.$toast.open({ message: e.message, type: 'is-danger' });
    }
  }

  async remove() {
    try {
      if (this.plant.id === undefined) return;
      await removePlant(this.plant.id);
      this.$router.push({ name: 'PlantList' });
      this.$toast.open(`Plant ${this.plant.name} deleted.`);
    } catch (e) {
      this.$toast.open({ message: e.message, type: 'is-danger' });
    }
  }
}
